import { Card, CardContent, CardHeader, Grid, makeStyles, Theme, Typography } from "@material-ui/core";
import { red } from "@material-ui/core/colors";
import { DangerousGoodsItem } from "../../graphql/generated/graphql";
import { DangerousGoodsPictograms } from "./DangerousGoodsPictograms";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    paddingLeft: theme.spacing(1),
  },
  card: {
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  cardHeader: {
    "& .MuiCardHeader-title": {
      fontWeight: "bold",
    },
  },
  cardContent: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingTop: 0,
    paddingBottom: 0,
  },
  item: {
    marginRight: theme.spacing(1),
  },
  iconAvatarClass: {
    backgroundColor: theme.palette.grey[300],
    color: red[600],
  },
  rightAlignItem: {
    marginLeft: "auto",
  },
}));

export default function Component(props: {
  Item: DangerousGoodsItem,
})
{
  const classes = useStyles();

  return <Grid item xs={12} sm={6} md={4} lg={3}>
    <Card className={classes.card}>
      <CardHeader className={classes.cardHeader} title={`${props.Item.UNNumber}`}
        subheader={props.Item?.DangerousGoodsTypeName}
        action={<DangerousGoodsPictograms key={props.Item?.OrderItemDangerousGoodsId} item={props.Item} />}
      />
      <CardContent className={classes.cardContent}>
        <Grid container>
          <Grid item className={classes.item}><Typography>{props.Item.Name}</Typography></Grid>
        </Grid>
        <Grid container>
          <Grid item className={classes.item}><Typography><b>Mennyiség:</b> {props.Item.Amount} {props.Item.AmountTypeName}</Typography></Grid>
          <Grid item className={`${classes.item} ${classes.rightAlignItem}`}><Typography><b>Csomagolás:</b> {props.Item.Quantity} {props.Item.PackageTypeName}</Typography></Grid>
        </Grid>
        <Grid container>
          <Grid item className={classes.item}><Typography><b>Pontszám:</b> {props.Item.Points}</Typography></Grid>
        </Grid>
      </CardContent>
    </Card>
  </Grid>;
}
